import { cn } from "app/lib/utils"
import { ComponentProps } from "react"
import ToolbarIconButton from "./ToolbarIconButton"

const IconButton = ({
  className,
  ...props
}: ComponentProps<typeof ToolbarIconButton>) => {
  return <ToolbarIconButton className={cn("bg-white", className)} {...props} />
}

export default IconButton
